export default (isOpenedDefault = true) => ({
	openedIndices: [],
	toggle(index) {
		this.openedIndices[index] = !this.openedIndices[index];
	},
	isOpen(index) {
		if (this.openedIndices[index] === undefined) {
			this.openedIndices[index] = isOpenedDefault;
		}
		return this.openedIndices[index];
	},

	accordionContents: [],

	isEmptyAccordion() {
		return (
			!this.accordionContents ||
			this.accordionContents === [] ||
			!this.accordionContents.reduce(
				(a, e) => (e?.downloads?.length && e.downloads.length > 0) || a,
				false
			)
		);
	},
});
